module.exports = __webpack_public_path__ + "img/ts-55x60.84bbfc6c.jpg";